var render = function render(){var _vm=this,_c=_vm._self._c;return _c('partner-form',{attrs:{"partner":_vm.newPartner}})
}
var staticRenderFns = []

export { render, staticRenderFns }